(window as any).global ||= window;
import { createRoot } from 'react-dom/client';

import '@fontsource-variable/montserrat/index.css';
import { DevServerGate } from '@invara-dev/react-base';
import { App } from './App';
import { API_URL } from './util/config';
import { getAxios } from './util/axios';

(window as any).getAxios = getAxios;

// Version 2: Using functions

const container = document.getElementById('root')!;

const root = createRoot(container);
root.render(
  <DevServerGate backendBaseUrl={API_URL}>
    <App />
  </DevServerGate>
);
